var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.4583 0.770814L6.00075 4.9975L1.54119 0.769064C1.36479 0.589689 1.13439 0.499564 0.903593 0.500002C0.672794 0.500002 0.441596 0.590127 0.264798 0.770814C0.0939992 0.944939 0.00559995 1.17156 0 1.39994L0 1.445C0.00559995 1.67338 0.0939992 1.9 0.264798 2.07413L5.36156 7.22963C5.53475 7.40638 5.76075 7.4965 5.98715 7.5H6.01235C6.23915 7.4965 6.46475 7.40638 6.63834 7.22963L11.7351 2.07413C12.0883 1.71406 12.0883 1.12956 11.7351 0.770814C11.5587 0.590127 11.3279 0.500002 11.0967 0.500002C10.8659 0.500002 10.6347 0.590127 10.4583 0.770814Z","fill":"#6F7881"}));
}

ChevronDown.defaultProps = {"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
